(ns hypnos.consumer.panels.consult.issues
  "The consult issues step."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:on-click (fn [_] (nav-fn state :issues :next))}
     (tr :ui.label/next)]]
   [:p.control
    [:button.button.is-rounded.is-light
     {:on-click (fn [_] (nav-fn state :issues :prev))}
     (tr :ui.label/prev)]]])

(defn- statement
  []
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.issues/statement)]]])

(defn- issues-field
  [state]
  [:div.field.has-check.is-horizontal
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.issues/question))]]
   [:div.field-body
    [:div.field
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :issue-claustrophobic
         :name      :issue-claustrophobic
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/issues :value])
                               :issue/claustrophobic)
         :on-change (fn [e]
                      (let [issues    (get-in @state [:consult :consult/issues :value])
                            old-value (contains? issues :issue/claustrophobic)
                            new-value (-> e .-target .-checked)
                            changed?  (or (get-in @state [:consult :consult/issues :dirty?])
                                          (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 conj :issue/claustrophobic)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 disj :issue/claustrophobic))
                        (swap! state assoc-in [:consult :consult/issues :dirty?] changed?)))
         :on-focus  (fn [_] (swap! state assoc-in [:consult :consult/issues :touched?] true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.issue/claustrophobic)]]]
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :issue-breathing
         :name      :issue-breathing
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/issues :value])
                               :issue/breathing)
         :on-change (fn [e]
                      (let [issues    (get-in @state [:consult :consult/issues :value])
                            old-value (contains? issues :issue/breathing)
                            new-value (-> e .-target .-checked)
                            changed?  (or (get-in @state [:consult :consult/issues :dirty?])
                                          (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 conj :issue/breathing)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 disj :issue/breathing))
                        (swap! state assoc-in
                               [:consult :consult/issues :dirty?]
                               changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/issues :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.issue/breathing)]]]
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :issue-eye
         :name      :issue-eye
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/issues :value])
                               :issue/eye)
         :on-change (fn [e]
                      (let [issues    (get-in @state [:consult :consult/issues :value])
                            old-value (contains? issues :issue/eye)
                            new-value (-> e .-target .-checked)
                            changed?  (or (get-in @state [:consult :consult/issues :dirty?])
                                          (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 conj :issue/eye)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 disj :issue/eye))
                        (swap! state assoc-in [:consult :consult/issues :dirty?] changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/issues :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.issue/eye)]]]
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :issue-nose
         :name      :issue-nose
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/issues :value])
                               :issue/nose)
         :on-change (fn [e]
                      (let [issues    (get-in @state [:consult :consult/issues :value])
                            old-value (contains? issues :issue/nose)
                            new-value (-> e .-target .-checked)
                            changed?  (or (get-in @state [:consult :consult/issues :dirty?])
                                          (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 conj :issue/nose)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 disj :issue/nose))
                        (swap! state assoc-in [:consult :consult/issues :dirty?] changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/issues :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.issue/nose)]]]
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :issue-forehead
         :name      :issue-forehead
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/issues :value])
                               :issue/forehead)
         :on-change (fn [e]
                      (let [issues    (get-in @state [:consult :consult/issues :value])
                            old-value (contains? issues :issue/forehead)
                            new-value (-> e .-target .-checked)
                            changed?  (or (get-in @state [:consult :consult/issues :dirty?])
                                          (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 conj :issue/forehead)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 disj :issue/forehead))
                        (swap! state assoc-in [:consult :consult/issues :dirty?] changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/issues :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.issue/forehead)]]]
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :issue-face
         :name      :issue-face
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/issues :value])
                               :issue/face)
         :on-change (fn [e]
                      (let [issues    (get-in @state [:consult :consult/issues :value])
                            old-value (contains? issues :issue/face)
                            new-value (-> e .-target .-checked)
                            changed?  (or (get-in @state [:consult :consult/issues :dirty?])
                                          (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 conj :issue/face)
                          (swap! state update-in
                                 [:consult :consult/issues :value]
                                 disj :issue/face))
                        (swap! state assoc-in [:consult :consult/issues :dirty?] changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/issues :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.issue/face)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The issues step"
  [state nav-fn]
  [:div.card-content
   ;; statement
   [statement]
   ;; field
   [issues-field state]
   [:hr]
   ;; navigation
   [navigation state nav-fn]])
